// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Show the dirty indicator on unclosable widgets. On hover, it should still show the dot instead of the X. */
/* https://github.com/arduino/arduino-pro-ide/issues/380 */
.p-TabBar.theia-app-centers
    .p-TabBar-tab.p-mod-closable.a-mod-uncloseable.theia-mod-dirty
    > .p-TabBar-tabCloseIcon:before {
    content: "\\ea71";
}

.monaco-list-row.show-file-icons.focused {
    background-color: var(--theia-quickInputList-focusBackground);
}

.monaco-editor .view-overlays .compiler-error {
    background-color: var(--theia-inputValidation-errorBackground);
    opacity: 0.4 !important;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/editor.css"],"names":[],"mappings":"AAAA,6GAA6G;AAC7G,0DAA0D;AAC1D;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,8DAA8D;IAC9D,uBAAuB;AAC3B","sourcesContent":["/* Show the dirty indicator on unclosable widgets. On hover, it should still show the dot instead of the X. */\r\n/* https://github.com/arduino/arduino-pro-ide/issues/380 */\r\n.p-TabBar.theia-app-centers\r\n    .p-TabBar-tab.p-mod-closable.a-mod-uncloseable.theia-mod-dirty\r\n    > .p-TabBar-tabCloseIcon:before {\r\n    content: \"\\ea71\";\r\n}\r\n\r\n.monaco-list-row.show-file-icons.focused {\r\n    background-color: var(--theia-quickInputList-focusBackground);\r\n}\r\n\r\n.monaco-editor .view-overlays .compiler-error {\r\n    background-color: var(--theia-inputValidation-errorBackground);\r\n    opacity: 0.4 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
